// eslint-disable-next-line no-confusing-arrow
export const TruncateText = (source, size) =>
  source && source.length > size ? `${source.slice(0, size - 1)}…` : source;
